import BackButtonToolbar from "features/BackButtonToolbar";
import { Create, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";

const CreateActivityForeignLanguages = () => {
  return (
    <Create
      title="Създаване на чужд език"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm>
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};

export default CreateActivityForeignLanguages;
